import { render, staticRenderFns } from "./ProductCardAudio.vue?vue&type=template&id=691c120e&scoped=true&"
import script from "./ProductCardAudio.vue?vue&type=script&lang=js&"
export * from "./ProductCardAudio.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardAudio.vue?vue&type=style&index=0&id=691c120e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c120e",
  null
  
)

export default component.exports